export const OTP_LENGTH = 6
export const SMS_RESEND_COOLDOWN_MS = 30_000
